import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export type WorkoutRequestOrPlaceHolder =
  | { date: string }
  | racehorse360.IWorkoutRequest;

export function isWorkoutRequest(
  input: WorkoutRequestOrPlaceHolder
): input is racehorse360.IWorkoutRequest {
  return "facility" in input;
}
